import styles from "./TokenInfo.module.css"
const TokenInfo = ({ posDetail, range, TempAPY, shareable }) => {

    
    
    const inRangeCircle = (
        <div className={styles.in_range_display}>
          <span
            className={
              range ? styles.range_text_positive : styles.range_text_negative
            }
          >
            {range ? "In Range" : "Out of Range"}
          </span>
        </div>
    );

    const TempAPYstyle = TempAPY > 30 ? "primary_apy" : TempAPY > 10 && TempAPY < 30 ? "secondary_apy" : "apy"

  return (
 
        <div className={styles.position_info_container}>
          <div className={styles.position_info_row}>
            <div className={styles.position_info_images}>
              <div className={styles.position_images}>
                <img src={posDetail.baseTokenImage} alt="token 1" width="30px" />
                <img src={posDetail.quoteTokenImage} alt="token 2" width="30px" />
              </div>
              <span className={styles.position_names}> {posDetail.baseTokenSymbol} / {posDetail.quoteTokenSymbol}</span>
            </div>
    
            <div className={styles.denomination_info}>
              <span>Denomination</span>
              <span>{posDetail.baseTokenSymbol}</span>
              <span>{posDetail.quoteTokenSymbol}</span>
            </div>
          </div>
          {/* ******************************* */}
    
          <div className={styles.position_info_row}>
            <div>
              <span className={styles.dollar_amount}>$2658.00</span>
              <span className={styles.percentage_change}>+8.57% | 24hr</span>
            </div>
                  <div>{ inRangeCircle}</div>
          </div>
              {/************************************/}
              
              <div className={ shareable ? styles.shareable_position : styles.position_info_row}>
              <span className={`${styles.apy_display} ${TempAPYstyle}`}> APY | {TempAPY}%</span>
              {
                  !shareable && (

                  <div className={styles.action_buttons}>
                      <button>Harvest</button>
                      <button>Reposition</button>
                      <button>Add</button>
                      <button>Remove</button>
                  </div>
                  )
              }
              </div>
        </div>
   
  )
}

export default TokenInfo